import type { SxProps, Theme } from '@mui/material';

export const TOOLBAR_CONTROL_HEIGHT = 40;

const TOOLBAR_CONTROL_SX = {
  backgroundColor: 'common.white',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '8px',
  height: TOOLBAR_CONTROL_HEIGHT,
} as const;

export const reportDatePickerSlotProps = {
  textField: {
    size: 'small' as const,
    sx: {
      width: 180,
      '& .MuiInputBase-root': {
        ...TOOLBAR_CONTROL_SX,
      },
      '& .MuiInputBase-input': { color: 'text.secondary' },
    },
  },
};

export const reportSearchInputSx: SxProps<Theme> = {
  width: '100%',
  '& .MuiInputBase-root': {
    ...TOOLBAR_CONTROL_SX,
    color: 'text.secondary',
  },
};

export const reportSearchContainerSx: SxProps<Theme> = { width: 280 };

export const reportFilterButtonWrapperSx: SxProps<Theme> = {
  '& .MuiButton-root': {
    ...TOOLBAR_CONTROL_SX,
    borderRadius: '8px',
    paddingX: 1.5,
    '&:hover': { backgroundColor: 'background.default' },
  },
};

export const reportIconButtonSx: SxProps<Theme> = {
  ...TOOLBAR_CONTROL_SX,
  width: TOOLBAR_CONTROL_HEIGHT,
  '&:hover': { backgroundColor: 'background.default' },
};

export const reportChartToggleButtonSx: SxProps<Theme> = {
  ...TOOLBAR_CONTROL_SX,
  textTransform: 'none',
  fontFamily: "'Inter', sans-serif",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
  gap: 0.75,
  px: 1.5,
  width: 'auto',
  color: 'inherit',
  '& svg': { color: 'currentColor' },
  '&:hover': { backgroundColor: 'background.default' },
  '&.Mui-selected': {
    backgroundColor: '#f5f6fa',
    borderColor: '#d6dbe7',
    color: '#2953ff',
    '&:hover': { backgroundColor: '#f5f6fa' },
  },
};

const VAYU_BLUE = '#2953ff';
const TRACK_BG = '#f5f6fa';
const TRACK_BORDER = '#d6dbe7';
const TRACK_TEXT = '#2d3949';

export const reportToggleGroupSx = (height = 32): SxProps<Theme> => ({
  height,
  borderRadius: '8px',
  border: '1px solid',
  borderColor: TRACK_BORDER,
  backgroundColor: TRACK_BG,
  overflow: 'hidden',
  '& .MuiToggleButtonGroup-grouped': {
    marginLeft: 0,
    border: 0,
    borderRadius: 0,
    '&:not(:first-of-type)': { marginLeft: 0 },
  },
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    fontFamily: "'Inter', sans-serif",
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
    color: TRACK_TEXT,
    px: 1.5,
    py: 0,
    backgroundColor: 'transparent',
    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
    '&.Mui-selected': {
      backgroundColor: 'common.white',
      color: VAYU_BLUE,
      '&:hover': { backgroundColor: 'common.white' },
    },
  },
});
